import { createReducer, on } from '@ngrx/store';
import { setSelectedLanguage, resetSelectedLanguage } from './language.actions';
import { LanguageState } from './language.state';

const initialLanguageState: LanguageState = {
  selectedLanguage: 'en' // Default is empty string (no language selected)
};

export const languageReducer = createReducer(
  initialLanguageState,
  on(setSelectedLanguage, (state, { selectedLanguage }): LanguageState => ({
    ...state,
    selectedLanguage
  })),
  on(resetSelectedLanguage, (): LanguageState => initialLanguageState)
);